import React, { useState, useEffect } from 'react';
import "./seminar.css";
import API from '../../../utils/apiCalling';
import { Link } from 'react-router-dom';
import { config, Base_Url } from '../../../utils/apiUrl';
import { get } from 'lodash';
import close_img from '../../../../src/assets/images/bullet/icon-close-white.png';
import HowToStartedModal from '../../../components/common/HowToStartedModal'
import SeminarLastPopUp from '../../../components/common/SeminarLastPopUp';
import { Carousel } from 'react-responsive-carousel';
import FirstStepModal from '../YourFirstStep/FirstStepModal'
import ErrorModal from './ErrorModal';
import validator from 'validator'
import LocationSelect from './LocationSelect';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Seminar = (props) => {
  const [display, setDisplay] = useState("none")
  const [popUp, setPopUp] = useState(false)
  const [popWarEduSeminar, setPopWarEduSeminar] = useState([])
  const [popUpLast, setPopUpLast] = useState(false)
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [openMsg1, setOpenMsg1] = useState(false)
  const [openMsg, setOpenMsg] = useState(false)
  const [Id, setId] = useState()
  const api = new API();
  const [warEduSeminar, setWarEduSeminar] = useState([]);
  const [advImgVal, setAdvImgVal] = useState([])
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [albumImageResult, setAlbumImageResult] = useState()
  const [locationData, setLocationData] = useState("")
  const [popupImg, setPopupImg] = useState("")
  const [popup, setPopup] = useState(false)
  const facebook = "https://www.facebook.com/login.php?skip_api_login=1&api_key=966242223397117&signed_next=1&next=https%3A%2F%2Fwww.facebook.com%2Fshare.php%3Fu%3Dhttp%253A%252F%252Fwww.malaysiawarrants.com.my%252Feducation%252Fseminar%253Fid%253D389%2526lang%253Den%26title%3Dtest%26description%3D%253Cp%253Etest%253C%252Fp%253E&cancel_url=https%3A%2F%2Fwww.facebook.com%2Fdialog%2Fclose_window%2F%3Fapp_id%3D966242223397117%26connect%3D0%23_%3D_&display=popup&locale=en_GB"
  const twitter = "https://twitter.com/intent/tweet?url=http%3A//www.malaysiawarrants.com.my/education/seminar%3Fid%3D389%26lang%3Den&text=test"
  const linkdein = "https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttp%253A%2F%2Fwww.malaysiawarrants.com.my%2Feducation%2Fseminar%253Fid%253D383%2526lang%253Den%26title%3D28JuneABCD123%26summary%3D%253Cp%253EMacquarie%2520Warrants%2520Malaysia%2520%2526lt%253Bhyperlink%2520to%2520malaysiawarrants.com.my%2526gt%253B%2520brings%2520you%2520its%2520very%2520first%2520webinar%2520which%2520will%2520be%2520focussed%2520on%2520the%2520global%2520technology%2520space.%2520Join%2520our%2520free%2520webinar%2520to%2520watch%2520our%2520guest%2520speaker%2520%253Cstrong%253EMartin%2520Wong%252C%2520the%2520Founder%2520of%2520TradeVSA%253C%252Fstrong%253E%252C%2520who%2520will%2520be%2520discussing%2520the%2520current%2520development%2520of%2520renewable%2520energy%2520and%2520electric%2520vehicles%2520globally%2520as%2520well%2520as%2520locally%252C%2520along%2520with%2520identifying%2520potential%2520stock%2520ideas%2520using%2520technical%2520charts%2520and%2520indicators.%253C%252Fp%253E%253Cp%253E%2526nbsp%253B%253C%252Fp%253E%253Cp%253EMeanwhile%252C%2520%253Cstrong%253EHeddy%2520Humaizi%253C%252Fstrong%253E%252C%2520%253Cstrong%253Ethe%2520Head%2520of%2520Institutional%2520Marketing%2520of%2520the%2520Inter-Pacific%2520Asset%2520Management%253C%252Fstrong%253E%252C%2520will%2520present%2520an%2520overview%2520of%2520the%2520global%2520technology%2520industry%252C%2520analysis%2520of%2520technology%2520stocks%252C%2520the%2520market%2520outlook%2520for%25202022%2520onwards%2520and%2520more%21%253C%252Fp%253E%253Cp%253E%2526nbsp%253B%253C%252Fp%253E%253Cp%253EYou%2520can%2520also%2520look%2520to%2520improve%2520your%2520knowledge%2520in%2520%253Cstrong%253Estructured%2520warrants%253C%252Fstrong%253E%2520which%2520will%2520be%2520covered%2520by%2520Macquarie%2520%2526lt%253Bhyperlink%2520to%2520malaysiawarrants.com.my%2526gt%253B%252C%2520where%2520you%2520can%2520learn%2520about%2520the%2520basics%2520of%2520warrants%2520as%2520well%2520as%2520types%2520of%2520warrants%2520that%2520will%2520allow%2520you%2520to%2520better%2520diversify%2520your%2520portfolio.%253C%252Fp%253E%253Cp%253E%2526nbsp%253B%253C%252Fp%253E%253Cp%253E%253Cstrong%253ERegister%2520for%2520this%2520event%2520for%2520free%21%2520%253C%252Fstrong%253EJoin%2520our%2520%253Cstrong%253Econtest%253C%252Fstrong%253E%2520during%2520the%2520webinar%2520and%2520%253Cstrong%253Ewin%2520great%2520prizes%253C%252Fstrong%253E%2520including%2520the%2520Mi%2520TV%2520and%2520Mi%2520Watch%2520Light%2520by%2520being%2520the%2520fastest%2520to%2520answer%2520the%2520quiz%2520questions%2520correctly.%2520View%2520more%2520information%2520and%2520terms%2520and%2520conditions%2520%253Ca%2520target%253D%2522_blank%2522%2520href%253D%2522https%253A%252F%252Fwww.malaysiawarrants.com.my%252FHKunderlyings%2522%253Ehere%253C%252Fa%253E.%253C%252Fp%253E%253Cp%253E%2526nbsp%253B%253C%252Fp%253E%253Cp%253E%253Cstrong%253EWebinar%2520schedule%2520%253C%252Fstrong%253E%253C%252Fp%253E%253Cp%253E9.15am%253A%2520Bursa%2520opening%2520speech%2520%28Azhar%2520Zabidi%252C%2520Bursa%2520Malaysia%29%253C%252Fp%253E%253Cp%253E9.30am%253A%2520Demystifying%2520renewable%2520energy%2520and%2520electric%2520vehicles%2520globally%2520%28Martin%2520Wong%252C%2520TradeVSA%29%253C%252Fp%253E%253Cp%253E10.15am%253A%2520Deepen%2520your%2520knowledge%2520in%2520structured%2520warrants%2520%28Liyana%2520Majid%252C%2520Macquarie%29%253C%252Fp%253E%253Cp%253E11.00am%253A%2520Break%2526nbsp%253B%2526nbsp%253B%253C%252Fp%253E%253Cp%253E11.10am%253A%2520The%2520intricacies%2520in%2520technology%2520industry%2520%28Heddy%2520Humaizi%252C%2520Inter-Pacific%2520Asset%2520Management%29%253C%252Fp%253E%253Cp%253E12.00pm%253A%2520Closing%253C%252Fp%253E%253Cp%253E%2526nbsp%253B%253C%252Fp%253E%253Cp%253E%253Cstrong%253EGuest%2520speaker%25201%253A%2520Martin%2520Wong%253C%252Fstrong%253E%253C%252Fp%253E%253Cp%253EMartin%2520Wong%2520is%2520a%2520co-founder%2520of%2520TradeVSA%2520System%2520and%2520is%2520currently%2520a%2520full-time%2520investor%2520and%2520trader%252C%2520who%2520dedicates%2520his%2520time%2520and%2520resources%2520to%2520nurture%2520the%2520youth%2520in%2520financial%2520literacy.%2520He%2520often%2520speaks%2520at%2520brokers%2526rsquo%253B%2520seminars%252C%2520webinars%2520and%2520was%2520previously%2520seen%2520on%2520the%2520New%2520Strait%2520Times%2520newspaper%252C%2520NTV7%252C%2520Trading%2520View%2520and%2520BFM%2520Radio%2520Station.%2520Previously%252C%2520he%2520held%25203%2520licences%2520in%2520stocks%252C%2520futures%2520and%2520fund%2520management%2520in%2520CIMB%2520Investment%2520Bank%252C%2520Jupiter%2520Securities%2520and%2520Philip%2520Capital%2520Asset%2520Management.%2520Among%2520his%2520roles%2520include%2520managing%2520funds%2520with%2520securities%2520listed%2520on%2520Bursa%2520Malaysia%252C%2520Singapore%2520Exchange%252C%2520and%2520the%2520US%2520markets.%2520He%2520also%2520wrote%2520four%2520books%2520on%2520investment%2520and%2520trading%252C%2520which%2520became%2520best%2520sellers%2520among%2520local%2520financial%2520books.%2526nbsp%253B%253C%252Fp%253E%253Cp%253E%2526nbsp%253B%253C%252Fp%253E%253Cp%253E%253Cstrong%253EGuest%2520speaker%25202%253A%2520Heddy%2520Humaizi%2520%253C%252Fstrong%253E%253C%252Fp%253E%253Cp%253EHeddy%2520Humaizi%2520is%2520the%2520Head%2520of%2520Institutional%2520Marketing%2520at%2520Inter-Pacific%2520Asset%2520Management%2520%28IPAM%29%2520and%2520is%2520part%2520of%2520the%2520Investment%2520Team%2520at%2520IPAM.%2520He%2520currently%2520provides%2520an%2520advisory%2520role%2520to%2520corporates%2520and%2520heads%2520the%2520Research%2520Unit.%2520Prior%2520to%2520joining%2520IPAM%252C%2520Heddy%2520was%2520the%2520Director%2520of%2520Institutional%2520Sales%2520and%2520Marketing%2520and%2520the%2520Sukuk%2520Portfolio%2520Manager%2520for%2520Saturna%2520Sdn%2520Bhd%2520%28Saturna%29%252C%2520overseeing%2520the%2520business%2520development%2520and%2520sale%2520of%2520funds%252C%2520while%2520also%2520overseeing%2520any%2520mandates%2520and%2520funds%2520managed%2520by%2520Saturna.%2520Heddy%2520has%2520more%2520than%252020%2520years%2520of%2520experience%2520in%2520the%2520stockbroking%2520and%2520fund%2520management%2520industry.%253C%252Fp%253E%253Cp%253E%2526nbsp%253B%253C%252Fp%253E"

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow:1,
    slidesToScroll: 1,
    dots: false,
    arrow: false,
  };


  useEffect(() => {
    getHomePopup()
  }, [])
  const getHomePopup = async () => {
    let homePopupResult = await api.get(
      config.advImgPopup,
      true,
    );
    let items = [];
    if(homePopupResult.length > 0){
      for (let i = 0; i < homePopupResult.length; i++) {
        let advImgData = await api.get(config.advImgData, true, {adv_id:homePopupResult[i].id});
        items.push({
          imgSrc: advImgData,
          link: homePopupResult[i].link
        })
      }
      setAdvImgVal(items)
    }
  };


  useEffect(() => {
    getWarEduSeminar();
  }, [])

  const getWarEduSeminar = async () => {
    let WarrentEduSeminar = await api.get(config.warrentEducationsSeminar, true, { type: "s", qid: Date.now() })
    let WarrentEducationSeminar = get(WarrentEduSeminar, 'seminarList', [])
    setWarEduSeminar(WarrentEducationSeminar)
    var resultData = WarrentEducationSeminar
        var imgData = {}
        if(resultData){                
            for(var i = 0; i < resultData.length; i++){
                const response = await fetch(`${Base_Url}/apimqmy/photo?seminar=${resultData[i].id}&lang=en`)
                const json = await response.json()
                var temp = {};
                imgData[resultData[i].id] = json
            }
            setAlbumImageResult(imgData)
        }
  };

  const onReadMore = (id, imgData) => {
    setDisplay("block")
    var pop = warEduSeminar.filter((data) => {
      return data.id == id
    })
    var popImg  = imgData
    setPopWarEduSeminar(pop)
    setPopupImg(popImg)
  }

  const displayNone = () => {
    setDisplay("none")
  }

  const onClickPopHandle = (url, title, value, id,thirdparty, date) => {
    setDisplay("none")
    setOpen(value);
    setUrl(url);
    setId(id)
    if (thirdparty == "1") {
      setPopUp(true)
      setPopUpLast(false)
    }
    else if (new Date().getTime() > new Date(date).getTime()) {
      if(url){
        window.open(url)
      }else{
        setPopup(true)
      }
    }else if (new Date().getTime() < new Date(date).getTime()) {
      setPopUpLast(true)
      setPopup(false)
    }
    else {
      setPopUp(false)
      setPopUpLast(false)
    }
  };

  const OnClickPopClose = () => {
    setDisplay("none")
  }

  const validateEmail = (e) => {
    var email = e.target.value
    if (validator.isEmail(email)) {
      setEmail(email)
    } else {
      setOpenMsg(true)
      setTimeout(() => setOpenMsg(false), [2000])
      setEmail()
    }
  }
  function valueSubmit(e) {
    if (!email) {
      setOpenMsg(true)
      setTimeout(() => setOpenMsg(false), [2000])
    }
    else {
      submitForm(e)
    }
  }

  const submitForm = async (e) => {
    e.preventDefault();
    let data = {
      email
    }
    let res = await api.post(`${config.subscription}${"?p=register"}`, data)
      .then((res) => {
        if(res.message == "Registration succeed"){
          submitForm1(e)
        }
        else{
          alert(res.message)
        }
      })
      .catch((error) => console.log(error))
  }

  const submitForm1 = async (e) => {
    e.preventDefault();
    let data = {
      email,
      name: name,
      location: locationData != "" ? locationData.join(",") : ""
    }
    let res = await api.post(`${config.regLocation}`, data)
      .then((res) => {
        if(res.message == "succeed"){
          setOpenMsg1(true)
          setTimeout(() => setOpenMsg1(false), [2000])
        }
        else{
          alert(res.message)
        }
      })
      .catch((error) => console.log(error))
  }

  return (
    <>
      <div id="seminar" className="pageobj" style={{}}>
        <div id="seminar_id" style={{ display: "none" }} />
        <div className="breadcrumbbar">
          <div className="container-fluid">
            <ol className="breadcrumb">
              <li>
                <Link to="/home?edu">Warrant education</Link>
              </li>
              <li className="active">Seminars</li>
            </ol>
          </div>
        </div>
        <div className="stripe-bg" />
        <div className="container-fluid">
          <div className="topimg">
            <img src="/img/bg/top-seminar.jpg" />
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8">
              <div className="section">
                <div className="page-header">
                  <h1>Seminars</h1>
                </div>
                <p>
                  Macquarie believes that investor education is essential for
                  trading warrants and is committed to improving the
                  understanding of investors. One of the best ways to improve
                  your understanding is to attend one of our free seminars.
                </p>
                <div id="nosmr" style={{ display: "none" }}>
                  <p>
                    There are no upcoming seminars for now. Tell us your
                    preferred location for our next seminar in the form below.
                    This also signs you up for our newsletter, allowing you to
                    receive seminar invitations.
                  </p>
                </div>
                <div id="smr-list">
                  {albumImageResult &&
                    warEduSeminar &&
                    warEduSeminar.map((curValue, curIdx) => (
                      <div key={curIdx} className="smr-row-v2" id="seminar-383">
                        <div className="smr-img">
                          <img
                            src={albumImageResult[curValue.id]}
                            style={{ width: "100%", height: "auto" }}
                          />
                        </div>
                        <div className="smr-body-v2">
                          <div className="smr-txt-area">
                            <div className="smr-datevenue">
                              <span className="smr-date-v2">
                                {curValue.date}
                              </span>{" "}
                              -{" "}
                              <span className="smr-venue-v2">
                                {curValue.en_venue}
                              </span>
                              <div className="smr-time-v2">
                                {curValue.en_time}
                              </div>
                            </div>
                            <div className="smr-title-v2">
                              {curValue.en_title}
                            </div>
                            <a
                              className="readmore"
                              onClick={() => onReadMore(curValue.id, albumImageResult[curValue.id])}
                            >
                              Read more
                            </a>
                          </div>
                          <div className="btn-area-v2">
                            <div className="bookBtn-area">
                        
                                <input
                                  className="bookBtn-v2 bgcolor-06"
                                  defaultValue="Register"
                                  type="button"
                                  onClick={() =>
                                    onClickPopHandle(
                                      curValue.link,
                                      curValue.en_title,
                                      true,
                                      curValue.id,
                                      curValue.thirdparty,
                                      curValue.date
                                    )
                                  }
                                />
                            </div>
                            <div className="shareBtn-area">
                              <div className="shareToLabel">Share to:</div>
                              <a
                                className="shareBtn facebookBtn"
                                href={facebook}
                                target="_blank"
                              />
                              <a
                                className="shareBtn twitterBtn"
                                href={twitter}
                                target="_blank"
                              />
                              <a
                                className="shareBtn instagramBtn"
                                href={linkdein}
                                target="_blank"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                <div id="havesmr" style={{ marginTop: "15px" }}>
                  <p>
                    No upcoming seminars near you? Tell us your preferred
                    location for our next seminar in the form below. This also
                    signs you up for our newsletter, allowing you to receive
                    seminar invitations.
                  </p>
                </div>

                <div className="location-form">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <input
                    type="text"
                    id="email"
                    name="email"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => {
                      validateEmail(e);
                      setOpenMsg(false);
                    }}
                  />
                  <span className="multiselect-native-select">
                    <div className="Input-tag" style={{ width: "50%" }}>
                      <LocationSelect setLocationDataVal={setLocationData} />
                    </div>
                  </span>
                  <div>
                    <button
                      className="btn btn-primary"
                      id="submit-location-form"
                      onClick={(e) => valueSubmit(e)}
                    >
                      Submit
                    </button>
                  </div>
                  <p
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                    className="small"
                  >
                    Also signs you up for our daily newsletter. Be the first to
                    receive market updates and seminar invitations.
                  </p>
                  <p
                    className="small"
                    style={{
                      fontStyle: "italic",
                      paddingTop: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    By clicking “Submit”, you confirm that you would like to
                    receive Macquarie’s daily newsletter and invitations for
                    warrant seminars, and you acknowledge that Macquarie’s
                    website administrators may have access to your personal data
                    for the processing of such data on behalf of Macquarie
                    Capital Securities (Malaysia) Sdn Bhd and other companies of
                    Macquarie group (“Macquarie”). You may view Macquarie’s
                    privacy policy with regard to collection and management of
                    personal data via the links at the bottom of this page.
                  </p>
                </div>
              </div>
            </div>
            <div className="hidden-xs hidden-sm col-md-4">
              <Slider {...settings} className="ad-section custom">
                {advImgVal &&
                  advImgVal.map((data, index) => {
                    return (
                      <a target="_blank" href={data.link} key={index}>
                        <div>
                          <img src={data.imgSrc} />
                        </div>
                      </a>
                    );
                  })}
              </Slider>
              <div className="section qlink-section">
                <div className="page-header">
                  <h2 className="small">Warrant videos</h2>
                </div>
                <p className="section-p">
                  Check out our guest speakers and animated education videos.
                </p>
                <div className="section-qlink-img section-qlink-dwvideo">
                  <Link
                    to="/education/warrantvideos"
                    className="section-qlink-achor"
                  >
                    <img src="/img/bullet/qlink-achor.png" />
                  </Link>
                </div>
              </div>
              <div className="section qlink-section">
                <div className="page-header">
                  <h2 className="small">Investor academy</h2>
                </div>
                <p className="section-p">
                  Everything you need to know about warrants.
                </p>
                <div className="section-qlink-img section-qlink-investoracademy">
                  <Link
                    target="_blank"
                    to="/edu"
                    className="section-qlink-achor"
                  >
                    <img src="/img/bullet/qlink-achor.png" />
                  </Link>
                </div>
              </div>
              <div className="section qlink-section">
                <div className="page-header">
                  <h2 className="small">Index warrants</h2>
                </div>
                <p className="section-p">
                  What is an index warrant and why is it so popular?
                </p>
                <div className="section-qlink-img section-qlink-indexdw">
                  <Link
                    to="/education/indexwarrants"
                    className="section-qlink-achor"
                  >
                    <img src="/img/bullet/qlink-achor.png" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="popup-customized"
        className="seminar-pop"
        style={{ display: display }}
      >
        {popWarEduSeminar &&
          popWarEduSeminar.map((popValue, popKey) => (
            <div key={popKey}>
              <div id="readmore_area">
                <img
                  className="btn-close"
                  style={{ top: "5px", right: "5px" }}
                  src={close_img}
                  onClick={() => {
                    displayNone();
                  }}
                />
                <div className="readmore-header">
                  <div className="shareBtn-area">
                    <div className="shareToLabel">Share to:</div>
                    <a
                      className="shareBtn facebookBtn"
                      href={facebook}
                      target="_blank"
                    />
                    <a
                      className="shareBtn twitterBtn"
                      href={twitter}
                      target="_blank"
                    />
                    <a
                      className="shareBtn instagramBtn"
                      href={linkdein}
                      target="_blank"
                    />
                  </div>
                  <div className="smr-datevenue">
                    <span className="smr-date-v2">{popValue.date}</span> -{" "}
                    {popValue.en_venue}
                    <div className="smr-time-v2">{popValue.en_time}</div>
                  </div>
                  <div className="smr-title-v2">{popValue.en_title}</div>
                </div>
                <div className="readmore-body">
                  <div className="smr-img">
                    <img
                      src={popupImg}
                      style={{ width: "100%", height: "auto" }}
                    />
                  </div>
                  <div className="content-pane">
                    <div
                      className="smr-content"
                      dangerouslySetInnerHTML={{ __html: popValue.en_content }}
                    ></div>
                    <div className="btn-area-v2">
                      <div className="bookBtn-area">
                          <input
                            className="bookBtn-v2 bgcolor-06"
                            defaultValue="Register"
                            type="button"
                            onClick={() =>
                              onClickPopHandle(
                                popValue.link,
                                popValue.en_title,
                                true,
                                popValue.id,
                                popValue.thirdparty,
                                popValue.date
                              )
                            }
                          />
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
      {popUp ? (
        <HowToStartedModal
          Url={url}
          Open={open}
          OpenModal={() => setOpen(!true)}
        />
      ) : null}
      {popUpLast ? (
        <SeminarLastPopUp
          Open={open}
          id={Id}
          OpenModal={() => setOpen(!true)}
          className="seminar"
        />
      ) : null}
      {openMsg1 && <FirstStepModal open={openMsg1} />}
      {openMsg && <ErrorModal open={openMsg} setOpenMsg={setOpenMsg} />}
      <div style={{display:popup?'table':'none'}} id="popup-customizedd">
        <div>
          <div id="book_areaa">
            <div className='book-area-register-expired'>
              <div className='page-headerr'>
                <img className='btn-closee' style={{position: 'absolute',cursor: 'pointer',top: '5px', right: '5px'}} src="/img/bullet/icon-close-white.png" alt="" onClick={() => {
                    setPopup(false);
                  }}/>
                <h1 style={{color: 'white',fontSize:'36px'}}>This seminar has been completed.</h1>
                </div>
                <p className='small' style={{fontSize:'18px',color: 'white'}}>Do stay tuned for more upcoming seminars with our
                <a href="/marketnews/subscribe" target="_blank" style={{color:'#66CCFF'}}> newsletter</a>, and follow us on 
                <a href="https://facebook.com/MalaysiaWarrants" target="_blank" style={{color:'#66CCFF'}}> Facebook</a> and 
                <a href="https://web.telegram.org/#/im?p=@Malaysiawarrants" target="_blank" style={{color:'#66CCFF'}}> Telegram</a>!
                </p>
              </div>
            
          </div>
        </div>
      </div>
    </>
  );
}
export default Seminar;
